export enum TreatmentErrorCode {
  CREATE_PATHWAY_FAILED = 'CREATE_PATHWAY_FAILED',
  PATHWAY_NOT_FOUND = 'PATHWAY_NOT_FOUND',
  INVALID_PREDICTION_RESPONSE = 'INVALID_PREDICTION_RESPONSE',
  TREATMENT_PROOF_DELETED = 'TREATMENT_PROOF_DELETED',
  TREATMENT_PROOF_ALREADY_DELETED = 'TREATMENT_PROOF_ALREADY_DELETED',
  TREATMENT_PROOF_DOCUMENT_DELETED = 'TREATMENT_PROOF_DOCUMENT_DELETED',
  TREATMENT_PROOF_NOT_FOUND = 'TREATMENT_PROOF_NOT_FOUND',
  TREATMENT_PROOF_DOCUMENT_NOT_FOUND = 'TREATMENT_PROOF_DOCUMENT_NOT_FOUND',
  HEALTH_HISTORY_JOURNEY_DEPRECATED = 'HEALTH_HISTORY_JOURNEY_DEPRECATED',
  WHOLE_PROFILE_INPUT_INVALID = 'WHOLE_PROFILE_INPUT_INVALID',
  INVALID_EMBRYO_CARRIER_RELATIONSHIP = 'INVALID_EMBRYO_CARRIER_RELATIONSHIP',
  OVERRIDE_PREDICTION_NUMBER_OF_ROUNDS_NOT_EQUAL_TO_CURRENT = 'OVERRIDE_PREDICTION_NUMBER_OF_ROUNDS_NOT_EQUAL_TO_CURRENT',
}
